

























































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { Toast } from 'vant'; 
import  dialogPanel  from "./dialogPanel.vue"
import { TbGoodsClass, TbMember } from "@/http";
 @Component({
    components: {dialogPanel},
}) 
export default class changeScorePanel extends Vue {
   
    public $refs!: {
       
    };

    @Prop({
        default:false
    })
    show:Boolean;
    @Prop({
        type:Object,
        default:()=>{
            return{
                id:"", 
                name:"", 
                phone:"",
                balance:"",
            } 
        }
    })
    memberInfo:any;
   


    title="积分调整";

    isloading=false;

    form={
        changeScore:null,
        scoreStatus:1,
        remarks:"",
    }
    userInfo:any={};

    async mounted() {
       
    }
    async created() {
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
    }

    async saveFun(){
        if(this.isloading) return;
        if(!this.form.changeScore){
            Toast("请输入调整积分");
            return;
        }
        if(Number(this.form.changeScore)==0){
            Toast("积分不可为0");
            return;
        }
        if(this.form.scoreStatus==1&&Number(this.form.scoreStatus)>9999999){
            Toast("积分最多增加9999999");
            return;
        }
        if(this.form.scoreStatus==2&&Number(this.form.changeScore)>Number(this.memberInfo.integral)){
            Toast(`积分最多减少${this.memberInfo.integral}`);
            return;
        }
        try {
            let obj = Object.assign({},this.form,{
                shopId:this.userInfo.shopId,
                memberId:this.memberInfo.id,
                memberName:this.memberInfo.name,
                phone:this.memberInfo.phone,
                balance:this.memberInfo.balance,
                cashierId:this.userInfo.id,
                cashier:this.userInfo.name,
                changeType:this.form.scoreStatus==1?4:5,
            })
            let res = await TbMember.AddMemberScore(obj);
            Toast("新增成功");
            this.isloading = false;
            this.closeFun();
            this.$emit("confirmSave")
        } catch (error) {
            this.isloading = false;
            
        }
    }
    resetForm(){
       this.form={
            changeScore:null,
            scoreStatus:1,
            remarks:"",
       } 
    }
    
    closeFun(){
        this.resetForm();
        this.$emit("closeFun");
    }
    changeStatus(val){
        this.form.scoreStatus = val;
    }
    handleInput(val){
        let xsIndex = val.toString().indexOf('.');
        if(xsIndex>-1){
            this.form.changeScore = this.form.changeScore.slice(0,xsIndex);
        }
        if(val<0){
            this.form.changeScore = 0;
        }else{
            if(val.toString().length>7){
                this.form.changeScore = this.form.changeScore.slice(0,7)
            }
        }
    }

}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/changeScorePanel.vue